import { get } from '../../lib/api/client';

/**
 * Locales — the `localeIds` filter every admin list and dashboard takes
 * (BE reqs §0.3). Empty `localeIds` = all locales.
 *
 *   GET /admin/locales/autocomplete?q=&limit=   fuzzy search, capped, no paging
 *   GET /locales/{id}                           one locale (names chips restored from the URL)
 */
export interface LocaleSummary {
  id: string;
  name?: string;
  type?: string;
  city?: string;
  stateProvince?: string;
  country?: string;
  postalCode?: string;
  lat?: number;
  lon?: number;
  radius?: number;
}

export function localeLabel(l: Pick<LocaleSummary, 'name' | 'city' | 'stateProvince' | 'postalCode' | 'id'>): string {
  return l.name || [l.city, l.stateProvince].filter(Boolean).join(', ') || l.postalCode || l.id;
}

export function localeDetail(l: LocaleSummary): string {
  return [l.city, l.stateProvince, l.postalCode].filter(Boolean).join(' · ');
}

export async function autocompleteLocales(q: string, limit = 10, signal?: AbortSignal): Promise<LocaleSummary[]> {
  const res = await get<LocaleSummary[] | null>('/admin/locales/autocomplete', { q, limit }, signal);
  return res ?? [];
}

export async function getLocale(id: string): Promise<LocaleSummary> {
  return get<LocaleSummary>(`/locales/${id}`);
}
